<template>
    <input
            ref="input"
            :value="value"
            v-on:input="updateValue($event.target.value)"
    >
</template>

<script>
    import _ from 'lodash';

    export default {
        name: "DecimalInput",

        props : ['value'],

        methods: {
            updateValue(value) {
                let formatted = _.chain(value).replace(/,(.+)/,".$1").toNumber().value();
                if(!_.isNaN(formatted) && !RegExp('\\.$').test(value)) {
                    this.$refs.input.value = formatted;
                    this.$emit('input', formatted)
                } else {
                    this.$emit('input', _.replace(value,/,/,"."))
                }
            }
        }
    }
</script>

<style scoped>

</style>